<div *ngIf="show" class="spinner-overlay">
    <div class="spinner">
      <div class="spinner-border"></div>
      <p class="spinner-text" *ngIf="message">{{ message }}</p>
    </div>
  </div>
  
 